document.addEventListener('alpine:initialized', () => {
    if (navigator.connection?.effectiveType !== '4g') {
        return;
    }

    const event = new MouseEvent('mouseenter', {
        view: window,
        bubbles: true,
        cancelable: true
    });

    document.querySelectorAll('.prefetch').forEach((element) => {
        element.dispatchEvent(event);
    });
});
